/**
 * Message list date helpers (local timezone, calendar-day semantics).
 */

export function formatMessageDateDividerLabel(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const now = new Date()
  if (d.toDateString() === now.toDateString()) return 'Today'

  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'

  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })
}

export function shouldShowMessageDateDivider(messages, index, getTimestamp) {
  if (!messages?.length || index < 0 || index >= messages.length) return false
  if (index === 0) return true
  const curr = getTimestamp(messages[index])
  const prev = getTimestamp(messages[index - 1])
  if (!curr || !prev) return true
  return new Date(prev).toDateString() !== new Date(curr).toDateString()
}

export function formatMessageTimeShort(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}

export function formatMessageDateTimeTitle(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
}
